import { useState } from "react";
import "./freepage.css";
import { BsChevronLeft } from "react-icons/bs";
import WalletPopup from "./WalletPopup.js";

function WalletPage({ btn, walletAmount, image }) {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="free-page w-100 py-5">
      <div className='content d-flex flex-column align-items-center'>
        <div className='img'>
          {/* Add any image or icon you want to display here */}
          {image}
        </div>
        <p>رصيدك الحالي: {walletAmount}KD</p>
      </div>
      <div className='d-flex justify-content-center' style={{ marginTop: '0px', marginBottom: '18px ' }}>
        <button className='btn' onClick={handleShowModal}>{btn}</button>
      </div>
      <WalletPopup show={showModal} onHide={handleCloseModal} />
    </div>
  );
}

export default WalletPage;
